import { useSelector, useDispatch } from "react-redux";
import {
  addProduct as addProductAction,
  delProduct as delProductAction,
  setProducts as setProductsAction,
  editProduct as editProductAction,
} from "../store/slices/products.slice.js";

import API from "../utils/api.js";

export default function useProducts() {
  const { products } = useSelector((s) => s.productsSlice);
  const dispatch = useDispatch();

  const addProduct = (product) => {
    dispatch(addProductAction(product));
  };

  const delProduct = (id) => {
    dispatch(delProductAction(id));
  };

  const editProduct = (id, data) => {
    dispatch(editProductAction({id, data}));
  };

  const fetchProducts = (token) => {
    API.getToken("/products/list", token).then((d) => {
      if (d.status === 200) {
        dispatch(setProductsAction(d.data.products));
      }
    });
  };

  return { products, addProduct, delProduct, fetchProducts, editProduct };
}
